import { render, staticRenderFns } from "./Goodies.vue?vue&type=template&id=6cf90d1d"
import script from "./Goodies.vue?vue&type=script&lang=ts"
export * from "./Goodies.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports